module.exports = __webpack_public_path__ + "static/media/1006203.fdb98ef2.png";